module.exports = __webpack_public_path__ + "img/project-edu-02.021941af.png";